import { createStylesContext } from '@salesforce/retail-react-app/app/components/shared/ui'

const [MyRewardsStylesProvider, useMyRewardsStyles] = createStylesContext('MyRewards')

export { MyRewardsStylesProvider, useMyRewardsStyles }
